import { render } from "./AdminTestView.vue?vue&type=template&id=44581580"
import script from "./AdminTestView.vue?vue&type=script&lang=js"
export * from "./AdminTestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__